import Vue from 'vue'
import VueRouter from 'vue-router'
import Stroe from '../store/index'
import {
  createRoutes
} from './createRouters'
import Home from '../views/home/Home.vue'
import Login from '../views/login/login.vue'
Vue.use(VueRouter) // 需要与引用VueRouter

// 数组 --> 动态子路由
let children = []
// 初始化默认路由
const initMenu = [{
    path: '/',
    redirect: '/Login',
  },
  {
    name: 'Login',
    path: '/Login',
    component: Login,
  },
]

// 初始化 router 实例
const createRouter = () =>
  new VueRouter({
    mode: 'hash',
    routes: initMenu,
  })
// 创建路由实例 -- 最终使用的
const router = createRouter()
// 根据权限生成路由方法
export function resetRouter() {
  // 创建路由实例 -- 用于赋值的
  const newRouter = createRouter()
  // 加载路由
  const menulist = Stroe.state.menulist
  // 调用createrouter方法
  createRoutes(children, menulist)
  const Menu = [{
    name: 'Home',
    path: '/Home',
    component: Home,
    children,
  }]
  // newRouter 添加路由
  newRouter.addRoutes(Menu)
  // 赋值 -- 完成创建路由
  router.matcher = newRouter.matcher
}
const routerPush = VueRouter.prototype.push
// 重定义router.push方法
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

// 路由访问前
router.beforeEach((to, before, next) => {
  // to 将要访问的路径
  // from 代表从那个路径跳转过来
  // next 是一个函数，表示放行
  // 判断是否到登陆页面
  if (to.path === '/Login') {
    children = []
    return next()
  }
  // 判断是否存在token
  if (!Stroe.state.accessToken) {
    return next('/Login')
  }
  // 判断路由是否动态加载
  if (children.length === 0) {
    // 加载路由
    resetRouter()
    return next(to.path)
  }
  // 登陆成功进入home
  if (to.path === '/Home') {
    return next('/HomeRedirect')
  }
  next()
  // history.pushState(null, null, location.href)
})
router.afterEach(() => {
  history.pushState(null, null, location.href)
})
export default router